import './property';
import './property-feed.component';
import './property-about.component';
import './property-memebers.component';
import './property-board.component';
import './property-files.component';
import './property-facilities.component';
